import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { createTeam, deleteTeam, editTeam } from 'modules/teams/store/teams/actions';
import { toApiError } from 'shared/errors';
import type { TeamsSliceState } from './teams-store';

type ReducerBuilder = ActionReducerMapBuilder<TeamsSliceState>;

/**
 * Реальные данные команд после мутаций перечитывает RTK Query по инвалидации
 * тегов, поэтому здесь остались только флаги хода операции.
 */
export function createCreateTeamReducer(builder: ReducerBuilder) {
  builder.addCase(createTeam.pending, (state) => {
    state.processing = true;
    state.processedName = 'createTeam';
  });

  builder.addCase(createTeam.fulfilled, (state) => {
    state.processing = false;
    state.processedName = undefined;
  });

  builder.addCase(createTeam.rejected, (state, action) => {
    state.processing = false;
    state.processedName = undefined;
    // Причина — в `payload` (`rejectWithValue(toApiError(e))`); `action.error.message` там — «Rejected».
    state.error = toApiError(action.payload ?? action.error).message || 'Unknown error';
  });
}

export function createEditTeamReducer(builder: ReducerBuilder) {
  builder.addCase(editTeam.pending, (state) => {
    state.processing = true;
    state.processedName = 'editTeam';
  });

  builder.addCase(editTeam.fulfilled, (state) => {
    state.processing = false;
    state.processedName = undefined;
  });

  builder.addCase(editTeam.rejected, (state, action) => {
    state.processing = false;
    state.processedName = undefined;
    // Причина — в `payload` (`rejectWithValue(toApiError(e))`); `action.error.message` там — «Rejected».
    state.error = toApiError(action.payload ?? action.error).message || 'Unknown error';
  });
}

export function createDeleteTeamReducer(builder: ReducerBuilder) {
  builder.addCase(deleteTeam.pending, (state) => {
    state.processing = true;
    state.processedName = 'deleteTeam';
  });

  builder.addCase(deleteTeam.fulfilled, (state) => {
    state.processing = false;
    state.processedName = undefined;
  });

  builder.addCase(deleteTeam.rejected, (state, action) => {
    state.processing = false;
    state.processedName = undefined;
    // Причина — в `payload` (`rejectWithValue(toApiError(e))`); `action.error.message` там — «Rejected».
    state.error = toApiError(action.payload ?? action.error).message || 'Unknown error';
  });
}
